export default class Cards {
  constructor() {

    if (!window.matchMedia('min-width: 481px')) {
      return;
    }

    // Array of all cards on the page
    this.cards = [...document.querySelectorAll('.card:not(.card--no-ratio)')];

    this.cardHeight = 0;

    // this.setHeight();
    // this.updateViewport();
  }

  setHeight() {
    this.cards.forEach((card) => {

      this.cardHeight = Math.ceil((card.offsetWidth / 4) * 5);
      card.style.setProperty('--card-minheight', `${this.cardHeight}px`);

      this.strechImage(card);
    });
  }

  updateViewport() {
    window.addEventListener('orientationchange', () => {
      this.setHeight();
    });
    window.addEventListener('resize',() => {
      this.setHeight();
    });
  }

  strechImage(card) {

    const content = card.querySelector('[data-card="content"]');
    if(!content) {
      return;
    }
    card.style.setProperty('--card-image-height', Math.ceil(this.cardHeight - content.offsetHeight) + "px");
  }
}
